import PT_BR from './pt-BR';
import ES from './es';
import EN from './en';

export default {
  'pt-BR': PT_BR,
  es: ES,
  en: EN,
};
